import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price: number): string {
  if (price >= 100000000) {
    // 1億 or more
    return `${(price / 100000000).toFixed(2)}億`;
  }
  if (price >= 10000) {
    // 1萬 or more
    return `${(price / 10000).toFixed(1)}萬`;
  }
  // Less than 1萬
  return price.toLocaleString('en');
}

/**
 * Get the backend API URL
 * This function returns the backend API URL based on the environment
 */
export function getBackendApiUrl(): string {
  // Use environment variable if available, or fallback to the default URL
  return process.env.API_HOST_URL || 'http://localhost:8080';
}
